// REACT
import React from 'react'

// VISTAS
import IndexView from 'Views/Index/Index'

const Index: React.FC = () => {
	return <IndexView />
}

export default Index
